const line = (function(){
    
    function _lineAnimation(){

        let getIdLine = document.querySelectorAll('#animation-line');

        function comprobAnimation(){

            getIdLine && getIdLine.forEach((data)=>{
                if(data.classList.contains('aos-animate')){
                    setTimeout(()=>{
                        data.classList.add('w100')
                    },300)
                }
            });

        }


        setTimeout(()=>{
            comprobAnimation();
        },800);

        window.addEventListener('scroll', comprobAnimation);
        
    }


    return {
        setHandleEvent: ()=>{
            try{
                _lineAnimation()
            }catch (error){ }
            
        }
    }

})();


const loadLineHandlers = ()=>{
    line.setHandleEvent()
}


export {
    loadLineHandlers
}